import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import App from './App';

console.log('Environment Debug:', {
  MODE: import.meta.env.MODE,
  API_URL: import.meta.env.VITE_API_URL
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);